<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      //
    }
  }
}
</script>

<style>
@import "./plugins/meltline.css";

html,
body {
  margin: 0;
  height: 100%;
  /* overflow: hidden; */
}
</style>
